'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var styles = require('@material-ui/styles');
var Tab = require('@material-ui/core/Tab');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Tab__default = /*#__PURE__*/_interopDefaultLegacy(Tab);

var SimpleTab = styles.withStyles(theme => ({
  root: _rollupPluginBabelHelpers.objectSpread2({
    textTransform: 'none',
    alignItems: 'flex-start',
    padding: 4,
    minWidth: 0,
    marginRight: theme.spacing(2)
  }, theme.typography.subtitle2),
  labelIcon: {
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 0,
    '& .MuiSvgIcon-root': {
      marginRight: 8,
      marginBottom: 0
    }
  }
}))(props => /*#__PURE__*/React__namespace.createElement(Tab__default['default'], _rollupPluginBabelHelpers['extends']({
  disableRipple: true
}, props)));

exports.SimpleTab = SimpleTab;
